import React, { createContext, useContext, useState } from "react";

import { getMrqs } from "../../api";

import { getHashdata } from "../../../../../../../../components/Tabs/Utils/hashFunctions";
import { fetchMrqThenBidData } from "./fetchMrqThenBidData";
import { useMcsContext } from "../../../MCS.context";

const BidContext = createContext({
  vendors: [],
  setVendors: () => {},

  openChatVendorIndex: [],
  setOpenChatVendorIndex: () => {},
});

export const useBidContext = () => useContext(BidContext);

function BidContextProvider({ children }) {
  const [openChatVendorIndex, setOpenChatVendorIndex] = React.useState("");
  const { plant, setSelectedBidMrqData } = useMcsContext();
  const [createdPos, setCreatedPos] = useState([]);

  const mrqData = plant.selectedBidMrq;
  console.log("after mrqData: ---------------------", mrqData);

  const [mrqList, setMrqList] = React.useState([]);
  const [mrqSelection, setMrqSelection] = React.useState({
    selectedMrq: "",
    revisions: [],
    selectedRevision: "",
  });
  const [BidTableRows, setBidTableRows] = React.useState();
  const [bidData, setBidData] = React.useState();
  const [selectedBidVendors, setSelectedVendors] = React.useState([]);

  const mrqId = getHashdata(window.location.hash, "mrq-id");

  React.useEffect(() => {
    const showMrqByUrl = async () => {
      console.log("after mrq ID : ---------------------", mrqId);
      mrqId &&
        fetchMrqThenBidData({
          plant,
          mrqSelection: { selectedMrq: mrqId },
          setBidData,
          setBidTableRows,
          setSelectedBidMrqData,
        });
      mrqId && setMrqSelection({ ...mrqSelection, selectedMrq: mrqId });
    };

    showMrqByUrl();
  }, []);

  React.useEffect(() => {
    const fetchMrqList = async () => {
      await getMrqs({ plantId: plant.id }).then((res) => setMrqList(res));
    };

    fetchMrqList();
  }, []);

  React.useEffect(() => {
    setSelectedVendors(mrqData?.vendors?.map((v) => v.name));
  }, [mrqData?.vendors]);

  React.useEffect(() => {
    const revisions = mrqData?.revs ? mrqData.revs : [];

    setMrqSelection({
      selectedMrq: mrqData?.id,
      revisions,
      selectedRevision: mrqData?.id,
    });
  }, []);

  React.useEffect(() => {
    fetchMrqThenBidData({
      plant,
      mrqSelection,
      setBidData,
      setBidTableRows,
      setSelectedBidMrqData,
    });
  }, [mrqSelection.selectedRevision, mrqSelection.selectedMrq]);

  const vendors = plant?.selectedMrq?.vendors;
  return (
    <BidContext.Provider
      value={{
        vendors: vendors || [],
        openChatVendorIndex,
        setOpenChatVendorIndex,

        mrqData: plant.selectedBidMrq,
        mrqList,
        mrqSelection,
        setMrqSelection,
        setSelectedBidMrqData,

        bidData,
        BidTableRows,
        setBidTableRows,

        selectedBidVendors,
        setSelectedVendors,

        createdPos,
        setCreatedPos,
      }}
    >
      {children}
    </BidContext.Provider>
  );
}

export { BidContextProvider, BidContext };
